module.exports = __webpack_public_path__ + "img/logo.7a9d1801.png";